"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Grid_1 = require("@material-ui/core/Grid");
const styles_1 = require("@material-ui/core/styles");
const classnames_1 = require("classnames");
const react_slick_1 = require("react-slick");
const ProgressiveCard_1 = require("../card/ProgressiveCard");
const settings = {
    dots: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true
};
const styles = (theme) => (0, styles_1.createStyles)({
    sectionBackground: {
        backgroundColor: theme.palette.primary.main,
        marginTop: theme.spacing(3)
    },
    carouselContainer: {
        '& .slick-track': {
            [theme.breakpoints.down('xs')]: {
                width: '90% !important'
            },
            '& .slick-slide': {
                [theme.breakpoints.down('xs')]: {
                    width: '100% !important'
                }
            }
        }
    }
});
const ProgressiveSection = ({ promotions, onPress, cornerIcon, classes }) => ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ container: true, direction: "row", alignItems: "center", className: classes.sectionBackground }, { children: (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ xs: 12, md: 12, item: true, className: (0, classnames_1.default)({
            [classes.carouselContainer]: !promotions || promotions.length === 0
        }) }, { children: (0, jsx_runtime_1.jsx)(react_slick_1.default, Object.assign({}, settings, { children: promotions.map((promotion) => ((0, jsx_runtime_1.jsx)(ProgressiveCard_1.default, { promotion: promotion, onPress: onPress, multiple: promotions.length > 1, cornerIcon: cornerIcon }, promotion.id))) })) })) })));
exports.default = (0, styles_1.withStyles)(styles)(ProgressiveSection);
//# sourceMappingURL=ProgressiveSection.js.map